import axios from "axios";
import Vue from "vue";
import { BASEURL, TOKEN } from "@/config/index";
// import router from '../router';

export default (params = {}) => {
  const { cinema_id = null } = params;
  const instance = axios.create({
    baseURL: BASEURL,
  });
  let JWT = window.localStorage.getItem("TOKEN")
    ? window.localStorage.getItem("TOKEN")
    : TOKEN;
  if (JWT) {
    instance.defaults.headers.common["Authorization"] = JWT;
  }
  instance.defaults.headers.common["x-cinema-source"] = "0";

  instance.defaults.headers.common["x-cinema-destination"] = cinema_id
    ? cinema_id
    : "0";
  // instance.defaults.headers.common['Authorization'] = Vue.cookie.get('STRHTID')
  // instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      return response;
    },
    function(error) {
      // Do something with response error
      if (error && error.response && error.response.status == 403) {
        // vmVue.$router.push({
        //   path: "/access-denied"
        // });
        Vue.toasted.show("You are not authorized");
      } else if (error && error.response && error.response.status == 401) {
        localStorage.clear();
        Vue.cookie.delete("BRHSID");
        vmVue.$router.push({
          path: "/", // '/go-to-login'
        });
      } else {
        return Promise.reject(error);
      }
    }
  );
  return instance;
};



// WEBPACK FOOTER //
// ./src/services/Api.js